<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-02-22 14:26:30
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:26:30
 -->
<template>
  <el-input
    class="base-input"
    v-bind="$attrs"
    placeholder="请输入"
    v-on="$listeners"
  >
    <slot
      slot="append"
      name="append"
    />
    <slot
      slot="prefix"
      name="prefix"
    />
  </el-input>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {},
  methods: {},
}
</script>

<style lang="less" scoped>
.base-input {
  /deep/.el-input__inner {
    height: 36px;
    line-height: 36px;
    border-color: #e1e1e1;
    &[disabled] {
      color: #606266;
      border-color: #e1e1e1;
    }
    &:focus {
      border-color: #3a6bd5;
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
    }
    &[type='number'] {
      -moz-appearance: textfield;
    }
  }
}
</style>
